import '../sass/style.scss';


import {
    Alert,
    Button,
    Carousel,
    Collapse,
    Dropdown,
    Modal,
    offcanvas,
    Popover,
    ScrollSpy,
    Tab,
    Toast,
    Tooltip
} from 'bootstrap';

const bootstrap = window.bootstrap = require('bootstrap');
gsap.registerPlugin(ScrollTrigger);

// Bind to the window
window.cf = {
    getOffsetTop(elem) {
        var offsetTop = 0;
        do {
            if (!isNaN(elem.offsetTop)) {
                offsetTop += elem.offsetTop;
            }
        } while (elem = elem.offsetParent);
        return offsetTop;
    },
    extend(a, b) {
        for (var key in b)
            if (b.hasOwnProperty(key))
                a[key] = b[key];
        return a;
    },
    parallaxAnimate(eleSelector, opts) {
        var defaults = {
            speed: 1,
            position: 0.85,
            setCallback: function () { },
            refreshCallback: function () { }
        };
        var options = cf.extend(defaults, opts);
        var elems = document.querySelectorAll(eleSelector);

        elems.forEach(function (elem, index) {
            if (!elem) {
                return;
            }
            options.setCallback(elem, index);
            document.addEventListener('scroll', function (e) {
                scrolledContent();
            }, false);
            scrolledContent();

            function scrolledContent() {
                let winHeight = window.innerHeight;
                let eleHeight = elem.offsetHeight;
                let scrollerPosition = window.pageYOffset || document.documentElement.scrollTop;
                let eleTopPosition = cf.getOffsetTop(elem);
                let topPosition;
                if (eleTopPosition + eleHeight < scrollerPosition || eleTopPosition > scrollerPosition + (winHeight * options.position)) {
                    return;
                }
                topPosition = window.scrollY - eleTopPosition + (winHeight * options.position) * options.speed;
                options.refreshCallback(elem, scrollerPosition, topPosition, index);

            }
        });

    },
    triggerAnimate(eleSelector, opts) {
        var defaults = {
            triggerPosition: 0.85,
            setCallback: function () { },
            refreshCallback: function () { }
        };
        var options = cf.extend(defaults, opts);

        var winHeight = window.innerHeight;
        var elems = document.querySelectorAll(eleSelector);

        elems.forEach(function (elem, index) {
            if (!elem) {
                return;
            }
            options.setCallback(elem, index);
            let eleStatus = true;
            document.addEventListener('scroll', function (e) {
                scrolledContent();
            });
            scrolledContent();
            function scrolledContent() {
                let ScrollerPosition = window.scrollY;
                let eleTopPosition = cf.getOffsetTop(elem);
                if (!eleStatus) {
                    return;
                }
                if (ScrollerPosition > (eleTopPosition - (winHeight * options.triggerPosition))) {
                    options.refreshCallback(elem, index);
                    eleStatus = false;
                }
            }
        });
    },
    fixedHeader(eleSelector, opts) {
        var defaults = {};
        var options = cf.extend(defaults, opts);
        var header = document.querySelector(eleSelector);
        if (!header) { return; }
        let headerHt = header.clientHeight;
        let lastScrollTop = 0;

        let button = header.querySelector('[data-bs-toggle="collapse"]');
        let myCollapse;

        if (button) {
            let buttonid = button.getAttribute("data-bs-target");
            myCollapse = header.querySelector(buttonid);
            myCollapse = bootstrap.Collapse.getOrCreateInstance(myCollapse, {
                toggle: false
            });
        }
        var navbar = header.querySelector(".navbar");
        function handleScroll() {
            var st = window.pageYOffset || document.documentElement.scrollTop;
            var scrollDisplayContainer = document.querySelector('[data-scroll-display-container]');

            if (st > 0) navbar.classList.remove("front-page-header");
            if (st > 200) {
                navbar.classList.add("bg-white");
                if (window.innerWidth > 991) {
                    if (navbar.classList.contains("navbar-dark")) {
                        navbar.querySelector(".btn").classList.remove("btn-primary");
                        navbar.querySelector(".btn").classList.add("btn-dark");
                    }
                }
            }
            else {
                navbar.classList.remove("bg-white");
                if (navbar.classList.contains("navbar-dark")) {
                    navbar.querySelector(".btn").classList.add("btn-primary");
                    navbar.querySelector(".btn").classList.remove("btn-dark");
                }
            }
            if (st === 0 && document.body.classList.contains('home')) navbar.classList.add("front-page-header");

            if (window.innerWidth < 992) {
                navbar.querySelector(".btn").classList.add("btn-primary");
                navbar.querySelector(".btn").classList.remove("btn-dark");
            }

            if (st > lastScrollTop) {
                header.style.top = "-" + headerHt + "px";
                if (button) {
                    myCollapse.hide();
                }
                hideNavbar(navButton, navMenu, navbar, true);

            } else {
                let windowWid = screen.width;
                if (scrollDisplayContainer && scrollDisplayContainer.classList.contains("active") && windowWid > 767) {
                    header.style.top = "-" + headerHt + "px";
                    if (button) {
                        myCollapse.hide();
                    }
                    hideNavbar(navButton, navMenu, navbar, true);
                } else {
                    // upscroll code
                    header.style.top = "0px";
                    if (button) {
                        myCollapse.hide();
                    }
                    hideNavbar(navButton, navMenu, navbar, false);
                }
            }

            lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
        }
        document.addEventListener('scroll', handleScroll, false);

        if (window.innerWidth < 992) {
            navbar.querySelector(".btn").classList.add("btn-primary");
            navbar.querySelector(".btn").classList.remove("btn-dark");
        }
    },
    mobileCheck() {
        let check = false;
        (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
        return check;
    }
};

window.counter = {
    numberCountSet(elem) {
        let elements = elem.querySelectorAll("[data-counter]");
        elements.forEach(function (element, index) {
            let innerText = element.getAttribute("data-counter");
            let str = "";
            for (let i = 0; i < innerText.length; i++) {
                str += "0";
            }
            element.innerHTML = str;
            element.style.display = "inline-block";
            setTimeout(function () {
                element.style.width = element.clientWidth + 1 + "px";
            }, 100);
        });
    },
    numberCount(elem) {
        let elements = elem.querySelectorAll("[data-counter]");
        setTimeout(function () {
            elements.forEach(function (element, index) {
                let x = 0;
                let count = parseInt(element.getAttribute("data-counter"));
                const myInterval = setInterval(myCounter, 20);
                function myCounter() {
                    x = x + 40;
                    element.innerHTML = x;
                    if (x >= count) {
                        clearInterval(myInterval);
                        element.innerHTML = count;
                        element.removeAttribute("style");
                    }
                }
            });
        }, 100);
    },
};


document.querySelectorAll('a[href^="#"]').forEach(function (anchor, index) {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();
        document.querySelector(this.getAttribute('href')).scrollIntoView({
            behavior: 'smooth'
        });
    });
});

var sidebarnav = document.querySelectorAll(".sideNav .nav-link");
if (sidebarnav) {
    let elems = [];
    sidebarnav.forEach(function (item, index) {
        item.addEventListener('click', function (event) {
            event.preventDefault();
            this.offsetParent.querySelector(".active").classList.remove("active");
            item.classList.add("active");
            let eleID = item.getAttribute("href");

            if (eleID != "#") {
                eleID = document.querySelector(eleID);
            }
            if (eleID && eleID != "#") {
                let num;
                if (screen.width > 768) {
                    num = 110;
                }
                else {
                    num = 70;
                }
                window.scrollTo({
                    top: window.cf.getOffsetTop(eleID) - num,
                    left: 0,
                    behavior: 'smooth'
                });
            }
        });

        let idelems = item.getAttribute("href");
        if (idelems != "#") {
            idelems = document.querySelector(idelems);

        }
        if (idelems && idelems != "#") {
            elems.push({
                index: index,
                item: item,
                offsetTop: window.cf.getOffsetTop(idelems) - 130,
                nextOffsetTop: (idelems.nextElementSibling) ? window.cf.getOffsetTop(idelems.nextElementSibling) - 130 : '999999',
            });
        }
        function moveScroll() {
            let scrollerPosition = window.pageYOffset || document.documentElement.scrollTop;
            if (elems[index] != undefined) {
                elems[index].item.classList.remove("active");
                if (scrollerPosition > elems[index].offsetTop && scrollerPosition < elems[index].nextOffsetTop) {

                    elems[index].item.classList.add("active");
                }
                else if (scrollerPosition < elems[0].offsetTop) {
                    elems[0].item.classList.add("active");
                }
            }
        }
        document.addEventListener('scroll', function (event) {
            moveScroll();
        });
        moveScroll();
    });
}

// testimonials slider
var testimonials = document.querySelector('.testimonials-gallery');
if (testimonials) {
    var currentSlide = 0;
    var testimonials_content = document.querySelectorAll('.testimonials-content');
    var testimonials_image = document.querySelectorAll('.testimonials-gallery-img img');
    var testimonials_control_left = document.querySelector('.testimonials-controls-left');
    var testimonials_control_right = document.querySelector('.testimonials-controls-right');

    testimonials_content.forEach((testimonial, i) => {
        gsap.set(testimonial, {
            display: i === 0 ? 'block' : 'none',
            opacity: i === 0 ? 1 : 0
        });
        gsap.set(testimonials_image[i], {
            position: i === 0 ? 'relative' : 'absolute',
            left: i * 100 + '%'
        });
    });

    if (testimonials_control_left && testimonials_control_right) {
        testimonials_control_left.addEventListener('click', () => {
            if (currentSlide == 0) return
            var prevSlide = currentSlide - 1;

            gsap.set(testimonials_control_right, {
                opacity: 1
            });

            if (prevSlide <= 0) {
                gsap.set(testimonials_control_left, {
                    opacity: .3
                });
            } else {
                gsap.set(testimonials_control_left, {
                    opacity: 1
                });
            }

            testimonials_image.forEach((image, i) => {
                gsap.to(image, {
                    left: (i - prevSlide) * 100 + '%'
                });
            });
            gsap.to(testimonials_content[currentSlide], {
                opacity: 0,
                onComplete: () => {
                    gsap.set('.testimonials-content', {
                        minHeight: testimonials_content[currentSlide].scrollHeight
                    });
                    gsap.set(testimonials_content[currentSlide], {
                        display: 'none'
                    });

                    currentSlide--;

                    gsap.set(testimonials_content[prevSlide], {
                        display: 'block'
                    });
                    gsap.to(testimonials_content[prevSlide], {
                        opacity: 1,
                        onComplete: () => {
                            gsap.to('.testimonials-content', {
                                minHeight: testimonials_content[prevSlide].scrollHeight,
                                onComplete: () => {
                                    gsap.set('.testimonials-content', {
                                        minHeight: 'initial'
                                    });
                                }
                            });
                        }
                    });
                }
            });
        });

        testimonials_control_right.addEventListener('click', () => {
            if (currentSlide == (testimonials_content.length - 1)) return
            var nextSlide = currentSlide + 1;

            gsap.set(testimonials_control_left, {
                opacity: 1
            });

            if (nextSlide >= (testimonials_content.length - 1)) {
                gsap.set(testimonials_control_right, {
                    opacity: .3
                });
            } else {
                gsap.set(testimonials_control_right, {
                    opacity: 1
                });
            }

            testimonials_image.forEach((image, i) => {
                gsap.to(image, {
                    left: (i - nextSlide) * 100 + '%'
                });
            });
            gsap.to(testimonials_content[currentSlide], {
                opacity: 0,
                onComplete: () => {
                    gsap.set('.testimonials-content', {
                        minHeight: testimonials_content[currentSlide].scrollHeight
                    });
                    gsap.set(testimonials_content[currentSlide], {
                        display: 'none'
                    });

                    currentSlide++;

                    gsap.set(testimonials_content[nextSlide], {
                        display: 'block'
                    });
                    gsap.to(testimonials_content[nextSlide], {
                        opacity: 1,
                        onComplete: () => {
                            gsap.set('.testimonials-content', {
                                minHeight: 'initial'
                            });
                        }
                    });
                }
            });
        });
    }
}

// new animations
var fadeInContainers = document.querySelectorAll('[data-fade-in-container]');
if (fadeInContainers) {
    fadeInContainers.forEach(item => {
        gsap.fromTo(item.querySelectorAll('[data-fold-in]'), {
            yPercent: 30,
            skewY: 2,
            scale: .8,
            rotateX: -80,
            opacity: 0
        }, {
            scrollTrigger: {
                id: 'fold-in-trigger',
                trigger: item,
                start: "top 75%",
                end: "bottom top",
                scrub: false,
                invalidateOnRefresh: true,
                toggleActions: "play none none none"
            },
            y: 0,
            yPercent: 0,
            skewY: 0,
            rotateX: 0,
            scale: 1,
            opacity: 1,
            ease: "expo.out",
            duration: 1.6,
            force3D: !0,
            overwrite: true,
            willChange: "transform"
        });
        gsap.fromTo(item.querySelectorAll('[data-fade-in]'), {
            opacity: 0
        }, {
            scrollTrigger: {
                id: 'fade-in-trigger',
                trigger: item,
                start: "top bottom",
                end: "bottom top",
                scrub: false,
                invalidateOnRefresh: true,
                toggleActions: "play none none none"
            },
            ease: "expo.out",
            duration: 2,
            stagger: .1,
            opacity: 1
        });
    })
}

var contentsTrigger = document.querySelectorAll('[data-intro-parent]');
if (contentsTrigger) {
    contentsTrigger.forEach(item => {
        let content = item.querySelector('[data-intro-content]');
        let img = item.querySelector('[data-intro-img]');
        gsap.fromTo(content, {
            yPercent: 100,
            skewY: 2,
            scale: .8,
            rotateX: -20,
            opacity: 0
        }, {
            scrollTrigger: {
                id: 'intro-trigger',
                trigger: item,
                start: "top bottom",
                end: "bottom top",
                scrub: false,
                invalidateOnRefresh: false,
                toggleActions: "restart none none none"
            },
            yPercent: 0,
            skewY: 0,
            rotateX: 0,
            scale: 1,
            ease: "expo.out",
            duration: 2.3,
            opacity: 1,
            delay: .25,
            force3D: !0,
            willChange: "transform"
        });
        gsap.fromTo(img, {
            yPercent: 100,
            skewY: -2,
            scale: .8,
            rotateX: -20,
            opacity: 1
        }, {
            scrollTrigger: {
                id: 'intro-img-trigger',
                trigger: item,
                start: "top bottom",
                end: "bottom top",
                scrub: false,
                invalidateOnRefresh: false,
                toggleActions: "restart none none none"
            },
            yPercent: 0,
            skewY: 0,
            rotateX: 0,
            scale: 1,
            ease: "expo.out",
            duration: 2.3,
            opacity: 1,
            delay: .25,
            force3D: !0,
            willChange: "transform"
        });
    });
};

import EmblaCarousel from 'embla-carousel';
import Autoplay from 'embla-carousel-autoplay';

document.addEventListener('DOMContentLoaded', () => {
    const sliderElements = document.querySelectorAll('.js-slider');
    sliderElements.forEach(slider => {
        const container = slider.querySelector('.js-container');
        const embla = EmblaCarousel(container, { 
            loop: true,
            speed: 10, 
            ease: 'ease-in-out' 
        }, [
            Autoplay({
                delay: 1500, 
                stopOnInteraction: false 
            })
        ]);
    });
});


var scrollProductContainer = document.querySelector('[data-scroll-product-container]');
var scrollProductBullets = document.querySelectorAll('[data-scroll-product-bullet] span');
var currentProductContent = 0;
window.addEventListener('DOMContentLoaded', () => {
    if (scrollProductContainer && scrollProductBullets) {
        let scrollProductImg = document.querySelectorAll('[data-scroll-product-container] [data-scroll-product-img]');
        let scrollProductContent = document.querySelectorAll('[data-scroll-product-container] .scrollProduct-content');
        let headingLine = document.querySelectorAll('[data-scroll-product-line] #line-box');

        scrollProductImg.forEach((image, i) => {
            if (i > 0) {
                gsap.set(image, {
                    display: 'none'
                })
            }
        })

        scrollProductContent.forEach((content, i) => {
            if (i > 0) {
                gsap.set(content, {
                    display: 'none'
                })
            }
        })

        scrollProductContainer.classList.remove('bg-white', 'bg-light', 'bg-warning');
        scrollProductContainer.classList.add(scrollProductContent[0].getAttribute('data-background'));

        scrollProductBullets[0].classList.add("active");

        animateSection(0);

        function animateSection(i) {

            const cards = document.querySelectorAll("[data-scroll-product-card]");
            cards.forEach(card => {
                if (i % 2 !== 0) {
                    card.classList.add('active')
                } else {
                    card.classList.remove('active')
                }
            });

            scrollProductContent.forEach((content, j) => {
                if (j == i) {
                    gsap.to(scrollProductContainer, {
                        delay: .5,
                        duration: .25
                    });
                    gsap.to(content, {
                        opacity: 0,
                        xPercent: -window.innerWidth / 3,
                        onComplete: () => {
                            scrollProductContainer.classList.remove('bg-white', 'bg-light', 'bg-warning');
                            scrollProductContainer.classList.add(content.getAttribute('data-background'));

                            if (scrollProductContainer.querySelector('.btn')) {
                                if (content.getAttribute('data-background') == 'bg-warning') {
                                    scrollProductContainer.querySelector('.btn').classList.remove('btn-primary');
                                    scrollProductContainer.querySelector('.btn').classList.add('btn-dark');
                                } else {
                                    scrollProductContainer.querySelector('.btn').classList.add('btn-primary');
                                    scrollProductContainer.querySelector('.btn').classList.remove('btn-dark');
                                }
                            }

                            gsap.set(content, {
                                display: 'block'
                            });
                            gsap.set(headingLine, {
                                yPercent: 0
                            });
                            gsap.to(content, {
                                opacity: 1,
                                xPercent: 0,
                                onComplete: () => {
                                    gsap.to(headingLine, {
                                        yPercent: 100,
                                        ease: "none",
                                        duration: .3
                                    });
                                }
                            });
                        }
                    });
                } else {
                    gsap.to(content, {
                        opacity: 0,
                        onComplete: () => {
                            gsap.set(content, {
                                display: 'none'
                            });
                        }
                    });
                }
            });

            scrollProductImg.forEach((image, j) => {
                if (j == i) {
                    gsap.to(image, {
                        y: window.innerHeight,
                        onComplete: () => {
                            gsap.set(image, {
                                display: 'block'
                            });
                            gsap.to(image, {
                                y: 0
                            });
                        }
                    });
                } else {
                    gsap.to(image, {
                        y: -window.innerHeight,
                        onComplete: () => {
                            gsap.set(image, {
                                display: 'none'
                            });
                            gsap.to(image, {
                                y: 0
                            });
                        }
                    });
                }
            });
        }

        scrollProductBullets.forEach((bullet) => {
            bullet.addEventListener('click', () => {
                const i = bullet.getAttribute('data-bullet');

                scrollProductBullets.forEach((bullet) => {
                    if (bullet.getAttribute('data-bullet') !== i) {
                        bullet.classList.remove("active");
                    } else {
                        bullet.classList.add("active");
                    }
                });

                if (i == currentProductContent) return
                animateSection(i);
                currentProductContent = i;

                // scrollProductContent.forEach((content, j) => {
                //     if (j == i) {
                //         gsap.set(content, {
                //             xPercent: -100
                //         });
                //         gsap.to(content, {
                //             opacity: content.style.opacity,
                //             xPercent: 0,
                //             onComplete: () => {
                //                 gsap.set(content, {
                //                     display: 'block'
                //                 });
                //                 gsap.to(content, {
                //                     opacity: 1
                //                 });
                //             }
                //         });
                //     } else {
                //         gsap.to(content, {
                //             opacity: 0,
                //             onComplete: () => {
                //                 gsap.set(content, {
                //                     display: 'none'
                //                 });
                //                 gsap.to(content, {
                //                     opacity: 0
                //                 });
                //             }
                //         });
                //     }
                // });

                // scrollProductImg.forEach((image, j) => {
                //     if (j == i) {
                //         gsap.to(image, {
                //             opacity: image.style.opacity,
                //             onComplete: () => {
                //                 gsap.set(image, {
                //                     display: 'block'
                //                 });
                //                 gsap.to(image, {
                //                     opacity: 1
                //                 });
                //             }
                //         });
                //     } else {
                //         gsap.to(image, {
                //             opacity: 0,
                //             onComplete: () => {
                //                 gsap.set(image, {
                //                     display: 'none'
                //                 });
                //                 gsap.to(image, {
                //                     opacity: 0
                //                 });
                //             }
                //         });
                //     }
                // });
            });
        });

        // ScrollTrigger.matchMedia({
        //     "(min-width: 576px)": () => {
        //         gsap.to(headingLine, {
        //             scrollTrigger: {
        //                 trigger: scrollProductContainer,
        //                 start: "top top",
        //                 end: `+=${scrollProductStartOffset + scrollProductDuration * scrollProductImg.length}px`,
        //                 pin: false,
        //                 scrub: 1,
        //                 invalidateOnRefresh: true,
        //                 toggleClass: { targets: scrollProductContainer, className: 'active' }
        //             },
        //             yPercent: 100,
        //             ease: "none"
        //         });
        //     },
        //     "(max-width: 575.98px)": () => {
        //         ScrollTrigger.create({
        //             trigger: scrollProductContainer,
        //             start: "top top",
        //             end: `+=${scrollProductStartOffset + scrollProductDuration * scrollProductImg.length}px`,
        //             pin: false,
        //             invalidateOnRefresh: true,
        //             onEnter: () => {
        //                 gsap.to(headingLine, {
        //                     yPercent: 100,
        //                     duration: 1,
        //                 });
        //             }
        //         });
        //     }
        // });

        // if (scrollProductImg) {
        //     scrollProductImg.forEach((img, i) => {
        //         let scrollProductContainerTop = scrollProductContainer.getBoundingClientRect().top;

        //         ScrollTrigger.matchMedia({
        //             "(min-width: 576px)": () => {
        //                 ScrollTrigger.create({
        //                     start: `${scrollProductContainerTop + scrollProductStartOffset + scrollProductDuration * i}px top`,
        //                     end: `+=${scrollProductDuration}`,
        //                     invalidateOnRefresh: true,
        //                     onEnter: () => animate(img, i),
        //                     onEnterBack: () => animate(img, i),
        //                     onLeave: () => animate(img, i),
        //                     onLeaveBack: () => animate(img, i)
        //                 });
        //             },
        //             "(max-width: 575.98px)": () => {
        //                 scrollProductContent.forEach((content, i) => {
        //                     if (i > 0) {
        //                         gsap.set(content, {
        //                             display: 'block'
        //                         })
        //                     }
        //                 })
        //             }
        //         });
        //     });
        // };

        function animate(img, i) {
            currentSection = i;
            scrollProductBullets.forEach((bullet, j) => {
                if (j !== i) {
                    scrollProductBullets[j].classList.remove("active");
                };
            });
            scrollProductBullets[i].classList.add("active");

            const cards = document.querySelectorAll("[data-scroll-product-card]");
            cards.forEach(card => {
                if (i % 2 !== 0) {
                    card.classList.add('active')
                } else {
                    card.classList.remove('active')
                }
            });

            scrollProductContent.forEach((content, j) => {
                if (j == i) {
                    gsap.set(content, {
                        xPercent: -100
                    });
                    gsap.to(content, {
                        opacity: content.style.opacity,
                        xPercent: 0,
                        onComplete: () => {
                            gsap.set(content, {
                                display: 'block'
                            });
                            gsap.to(content, {
                                opacity: 1
                            });
                        }
                    });
                } else {
                    gsap.to(content, {
                        opacity: 0,
                        onComplete: () => {
                            gsap.set(content, {
                                display: 'none'
                            });
                            gsap.to(content, {
                                opacity: 0
                            });
                        }
                    });
                }
            });

            scrollProductImg.forEach((image, j) => {
                if (j == i) {
                    gsap.to(image, {
                        opacity: image.style.opacity,
                        onComplete: () => {
                            gsap.set(image, {
                                display: 'block'
                            });
                            gsap.to(image, {
                                opacity: 1
                            });
                        }
                    });
                } else {
                    gsap.to(image, {
                        opacity: 0,
                        onComplete: () => {
                            gsap.set(image, {
                                display: 'none'
                            });
                            gsap.to(image, {
                                opacity: 0
                            });
                        }
                    });
                }
            });
        };
    }
});


var scrollDisplayContainer = document.querySelector('[data-scroll-display-container]');
var scrollDisplayLink = document.querySelectorAll('[data-scroll-display-link]');
var scrollDisplayBullet = document.querySelectorAll('[data-scroll-display-bullet]');
var scrollDisplayStartOffset = 0;
var scrollDisplayDuration = 1000;
var currentSection = 0;
window.addEventListener('DOMContentLoaded', () => {
    if (scrollDisplayContainer) {
        let scrollDisplayImg = document.querySelectorAll('[data-scroll-display-img]');

        gsap.set(scrollDisplayImg, {
            scale: 0,
            opacity: 0,
        });

        scrollDisplayLink.forEach((item, i) => item.addEventListener('pointerenter', () => {
            animateHover(scrollDisplayImg[i], i);
        }));

        ScrollTrigger.create({
            trigger: scrollDisplayContainer,
            start: "top top",
            end: `+=${scrollDisplayStartOffset + scrollDisplayDuration * scrollDisplayImg.length}px`,
            pin: false,
            invalidateOnRefresh: true,
            once: true,
            onEnter: () => {
                animate(scrollDisplayImg[0], 0);
            }
        });

        function animateHover(img, i) {
            scrollDisplayLink.forEach((link, j) => {
                if (j !== i) {
                    link.classList.remove("active");
                    scrollDisplayBullet[j].classList.remove("active");
                };
            });
            scrollDisplayLink[i].classList.add("active");
            scrollDisplayBullet[i].classList.add("active");

            scrollDisplayImg.forEach((image, j) => {
                if (j == i) {
                    gsap.to(image, {
                        scale: 1,
                        opacity: 1,
                        duration: 1,
                        transformOrigin: "50% 50%",
                    });
                } else {
                    gsap.to(image, {
                        scale: 0,
                        opacity: 0,
                        duration: .5,
                        overwrite: true,
                        transformOrigin: "50% 50%",
                    });
                }
            });

            let scrollDisplayLottie = img.classList.contains("animate-lottie");
            if (scrollDisplayLottie) {
                let dataId = img.getAttribute("data-id");

                lottie[dataId].stop();
                lottie[dataId].play();
            };
        };

        function animate(img, i) {
            currentSection = i;
            scrollDisplayLink.forEach((link, j) => {
                if (j !== i) {
                    link.classList.remove("active");
                    scrollDisplayBullet[j].classList.remove("active");
                };
            });
            scrollDisplayLink[i].classList.add("active");
            scrollDisplayBullet[i].classList.add("active");

            scrollDisplayImg.forEach((image, j) => {
                if (j == i) {
                    gsap.to(image, {
                        scale: 1,
                        opacity: 1,
                        duration: 1,
                        transformOrigin: "50% 50%",
                    });
                } else {
                    gsap.to(image, {
                        scale: 0,
                        opacity: 0,
                        duration: .5,
                        overwrite: true,
                        transformOrigin: "50% 50%",
                    });
                }
            });

            let scrollDisplayLottie = img.classList.contains("animate-lottie");
            if (scrollDisplayLottie) {
                let dataId = img.getAttribute("data-id");

                lottie[dataId].stop();
                lottie[dataId].play();
            };
        };

        function animateLeave(img, i) {
            gsap.to(img, {
                scale: 0,
                opacity: 0,
                duration: .5,
                transformOrigin: "50% 50%",
            });
        };
    };
});





window.animate = {
    headingSet(elem) {
        gsap.set(elem.querySelectorAll('h3,p'), {
            x: 100,
            opacity: 0,
        });
    },
    heading(elem) {
        gsap.to(elem.querySelectorAll('h3,p'), {
            x: 0,
            opacity: 1,
            duration: 1,
            stagger: 0.2
        });
    },
    slideupSet(elem) {
        gsap.set(elem.querySelectorAll('.card'), {
            y: 100,
            opacity: 0,
        });
    },
    slideup(elem) {
        gsap.to(elem.querySelectorAll('.card'), {
            y: 0,
            opacity: 1,
            duration: 1,
            stagger: 0.20
        });
    },
    // scrollDisplayLineSet(elem) {
    //     gsap.set(elem.querySelectorAll('.heading-line svg #line-box'), {
    //         yPercent: 0,
    //     });
    // },
    // scrollDisplayLine(elem) {
    //     gsap.to(elem.querySelectorAll('.heading-line svg #line-box'), {
    //         yPercent: 100,
    //         duration: 1,
    //     });
    // },
    // scrollDisplayImgSet(elem) {
    //     gsap.set(elem.querySelectorAll('.scrollDisplay-img img'), {
    //         scale: 0,
    //         opacity:0,
    //         transformOrigin: "50% 50%",
    //     });

    // },
    scrollDisplayImg(elem) {
        // gsap.to(elem.querySelectorAll('.scrollDisplay-img img'), {
        //     scale: 1,
        //     opacity: 1,
        //     duration: 1,
        //     stagger: 0.20,
        //     transformOrigin: "50% 50%",
        // });

        let animateEle = elem.querySelector('.animate-lottie');
        if (animateEle) {
            let dataId = animateEle.getAttribute("data-id");
            lottie[dataId].stop();
            lottie[dataId].play();
        }
    },
    textMediaSet(elem) {
        gsap.set(elem.querySelectorAll('.textMedia-img img'), {
            scale: 0,
            opacity: 0,
            transformOrigin: "50% 50%",
        });
    },
    textMedia(elem) {
        gsap.to(elem.querySelectorAll('.textMedia-img img'), {
            scale: 1,
            opacity: 1,
            duration: 1,
            stagger: 0.20,
            transformOrigin: "50% 50%",
        });
        let animateEle = elem.querySelector('.animate-lottie');
        let dataId = animateEle.getAttribute("data-id");
        lottie[dataId].play();
    },
    illustrationDisplaySet(elem) {

    },
    illustrationDisplay(elem) {
        let animateEle = elem.querySelectorAll('.animate-lottie');
        animateEle.forEach(function (item, index) {
            let dataId = item.getAttribute("data-id");
            lottie[dataId].play();
        });
    },
    illustrationTitleSet(elem) {
    },
    illustrationTitle(elem) {
        let animateEle = elem.querySelector('.animate-lottie');
        let dataId = animateEle.getAttribute("data-id");
        lottie[dataId].play();
    },
};



// cf.triggerAnimate(".slideup", {
//     setCallback: animate.slideupSet,
//     refreshCallback: animate.slideup,
//     triggerPosition: 0.65,
// });
// cf.triggerAnimate(".heading", {
//     setCallback: animate.headingSet,
//     refreshCallback: animate.heading,
//     triggerPosition: 0.65,
// });
cf.triggerAnimate(".textMedia", {
    setCallback: animate.textMediaSet,
    refreshCallback: animate.textMedia,
    triggerPosition: 0.40,
});
// cf.triggerAnimate(".scrollDisplay", {
//     setCallback: animate.scrollDisplayLineSet,
//     refreshCallback: animate.scrollDisplayLine,
//     triggerPosition: 0.40,
// });

// cf.triggerAnimate(".scrollDisplay", {
//     setCallback:animate.scrollDisplayImgSet,
//     refreshCallback:animate.scrollDisplayImg,
//     triggerPosition: 0.2,
// });

cf.triggerAnimate(".illustrationDisplay", {
    setCallback: animate.illustrationDisplaySet,
    refreshCallback: animate.illustrationDisplay,
    triggerPosition: 0.2,
});
cf.triggerAnimate(".illustrationTitle", {
    setCallback: animate.illustrationTitleSet,
    refreshCallback: animate.illustrationTitle,
    triggerPosition: 0.2,
});


var count = 0;
var lastTop = 0;
var timer = null;
var triggerTabList = [].slice.call(document.querySelectorAll('#scroll-tab [data-bs-toggle="tab"]'));

triggerTabList.forEach(function (triggerEl, index) {
    var tabTrigger = new bootstrap.Tab(triggerEl);
    triggerEl.addEventListener('click', function (event) {
        event.preventDefault();
        count = index + 1;
        tabTrigger.show();
    });
});


let pager = document.querySelector(".scrollDisplay-pager");
triggerTabList.forEach(function (item, index) {
    let span = document.createElement("span");
    if (index == 0) {
        span.classList.add("active");
    }
    pager.append(span);
});

var vButton = document.querySelector(".media-video--button");

if (vButton) {
    vButton.addEventListener("click", function () {
        var video = vButton.getAttribute("data-id");
        video = document.getElementById(video);
        if (video.paused) {
            video.play();
            vButton.classList.add("pause");
        } else {
            video.pause();
            vButton.classList.remove("pause");
        }
    });
}



//trigger Animatin on tab change

// triggerTabList.forEach(function (tabEl,index) {
//     tabEl.addEventListener('shown.bs.tab', function (event) {

//         cf.triggerAnimate(event.target.getAttribute("data-bs-target"), {
//             setCallback:animate.scrollDisplayImgSet,
//             refreshCallback:animate.scrollDisplayImg,
//             triggerPosition: 0.7,
//         });

//         let pager = document.querySelectorAll('.scrollDisplay-pager span');
//         if(pager[index].offsetParent != null){
//             pager[index].offsetParent.querySelector(".active").classList.remove("active");
//             pager[index].classList.add("active");
//         }
//     });
// });



window.pAnimate = {
    introSet(elem) {
        gsap.set(elem.querySelectorAll('.intro-line svg #box'), {
            y: 0,
        });
    },
    intro(elem, scroller, topPosition) {
        let childs = elem.querySelectorAll('.col-12');
        let myvalue = 0;
        let childvalue;

        childs.forEach(function (child, index) {
            childvalue = child.offsetHeight / 2 + child.offsetTop;
            if (topPosition < childvalue) {
                if (topPosition >= myvalue) {
                    myvalue = childvalue;
                }
            }
        });
        if (myvalue == 0) {
            myvalue = childvalue;
        }
        gsap.to(elem.querySelectorAll('.intro-line svg #box'), {
            duration: 2,
            y: myvalue - 50,
        });
    },
    // scrollDisplaySet(elem) {
    //     elem.style.height = elem.offsetHeight +1500+"px";
    //     let eleTopPadding = window.getComputedStyle(elem).getPropertyValue('padding-top');
    //     let elemContainer  = elem.querySelector(".scrollDisplay-container");
    //     elemContainer.style.top = eleTopPadding;
    // },
    // scrollDisplay(elem,scroller,topPosition) {
    //     if(timer !== null) {
    //         clearTimeout(timer);
    //     }

    //     timer = setTimeout(function() {
    //         // do something
    //         let eleHeight = elem.offsetHeight;
    //         let winHeight = window.innerHeight;
    //         let eleTopPosition = cf.getOffsetTop(elem);

    //         if (scroller > lastTop ){
    //             count++;
    //             if(count==triggerTabList.length){
    //                window.scroll(0,eleTopPosition+eleHeight-winHeight);
    //             }
    //             if(count>=triggerTabList.length){
    //                 count=triggerTabList.length
    //             }
    //             let triggerEl = document.querySelector('#scroll-tab [data-bs-target="#tab'+count+'"]');
    //             bootstrap.Tab.getOrCreateInstance(triggerEl).show(); // Select tab by name

    //         } else {
    //             if(scroller+winHeight < eleTopPosition+eleHeight){
    //                 count--;
    //                 if(count==1){
    //                     window.scroll(0,eleTopPosition);
    //                 }
    //                 if(count<=1){
    //                     count=1
    //                 }
    //                 let triggerEl = document.querySelector('#scroll-tab [data-bs-target="#tab'+count+'"]');
    //                 bootstrap.Tab.getOrCreateInstance(triggerEl).show(); // Select tab by name
    //             }
    //         }
    //         lastTop = scroller <= 0 ? 0 : scroller; // For Mobile or negative scrolling
    //     }, 150);
    // },

    sideNavFixedSet(elem) {
        gsap.set(".sidebar", {
            y: 0,
        });
    },

    sideNavFixed(elem, scroller, topPosition) {
        if (screen.width < 768) {
            let sidebar = document.querySelector(".sideNav");
            let eleHeight = elem.offsetHeight;
            let eleTopPosition = cf.getOffsetTop(elem);
            if (topPosition > 100 && eleHeight + eleTopPosition > (scroller + 100)) {
                console.log(scroller);
                sidebar.classList.add("fixed");
            }
            else {
                setTimeout(function () {
                    sidebar.classList.remove("fixed");
                }, 100);
            }
        }
    },
};


cf.parallaxAnimate(".location", {
    setCallback: pAnimate.sideNavFixedSet,
    refreshCallback: pAnimate.sideNavFixed,
    position: 0,
});

cf.parallaxAnimate(".intro", {
    setCallback: pAnimate.introSet,
    refreshCallback: pAnimate.intro,
    position: 0.50,
    speed: 1,
});

let windowWid = screen.width;
if (windowWid > 991) {
    // cf.parallaxAnimate(".scrollDisplay", {
    //     setCallback: pAnimate.scrollDisplaySet,
    //     refreshCallback: pAnimate.scrollDisplay,
    //     position: 0,
    //     speed: 1,
    // });
}




//trigger Animatin on tab change

/*var tabEls = document.querySelectorAll('#pills-tab button[data-bs-toggle="pill"]');
tabEls.forEach(function (tabEl) {
    tabEl.addEventListener('shown.bs.tab', function (event) {
        // cf.triggerAnimate(event.target.getAttribute("data-bs-target"), {
        //     refreshCallback:animate.tabingText,
        //     setCallback:animate.tabingTextSet,
        //     triggerPosition: 0.5,
        // });
    });
});*/


// open tab with #link

/*var hash = window.location.hash;
if(hash){
    var triggerEl = document.querySelector('#pills-tab button[data-bs-target="'+hash+'"]');
    if(triggerEl != null){
        bootstrap.Tab.getInstance(triggerEl).show(); // Select tab by name
    }
}*/




cf.triggerAnimate(".numbers", {
    setCallback: counter.numberCountSet,
    refreshCallback: counter.numberCount,
    triggerPosition: 0.90,
});




//make header fixed on scroll;
cf.fixedHeader("header");


var navButton = document.querySelector(".navbar-toggler");
var navMenu = document.querySelector(".navbar-nav");
var navbar = document.querySelector(".navbar");

function hideNavbar(navButton, navMenu, navbar, white) {
    navButton.classList.remove("collapsed");
    navMenu.classList.remove("show");
    if (white) {
        navbar.classList.add("bg-white");
    }
}

navButton.addEventListener("click", function () {
    // Check if Cookiebot is available and if it is open, close it
    if (typeof Cookiebot !== 'undefined' && 
        Cookiebot !== null && 
        typeof Cookiebot.consent === 'object' && 
        typeof Cookiebot.consent.marketing === 'boolean'
    ) {
        if (navMenu.classList.contains("show")) {
            dataLayer.push({
                'event': 'main_menu',
                'event_info': [{
                    'user_interaction': 'hamburger_menu_close',
                    'navigation_selection': 'not_available',
                }]
            });
        }
        else {
            dataLayer.push({
                'event': 'main_menu',
                'event_info': [{
                    'user_interaction': 'hamburger_menu_open',
                    'navigation_selection': 'not_available',
                }]
            });
        }
    }
    navButton.classList.toggle("collapsed");
    navMenu.classList.toggle("show");


    let st = window.pageYOffset || document.documentElement.scrollTop;
    if (st > 200) {
        navbar.classList.toggle("bg-white");
    }
    else {
        navbar.classList.remove("bg-white");
    }
});


// dropdown on hover

var dropdownElementList = [].slice.call(document.querySelectorAll('[data-bs-toggle="dropdown"]'));
dropdownElementList.forEach(function (dropdownToggleEl) {
    var dropdown = new bootstrap.Dropdown(dropdownToggleEl);
    dropdownToggleEl.addEventListener('click', function (event) {
        window.location.href = dropdownToggleEl.getAttribute("href");
    });
    dropdownToggleEl.addEventListener('mouseenter', function () {
        dropdown.show();
    });
    dropdownToggleEl.offsetParent.addEventListener('mouseleave', function () {
        dropdown.hide();
    });
});

// tabs on hover

var isMobile = window.cf.mobileCheck();
if (!isMobile) {

}

// var tabElementList = [].slice.call(document.querySelectorAll('.scrollDisplay [data-bs-toggle="tab"]'));
// tabElementList.forEach(function (tabToggleEl) {
//     var tab = new bootstrap.Tab(tabToggleEl);
//     tabToggleEl.addEventListener('click', function (event) {

//         setTimeout(function() {
//             console.log("testing2");
//             window.location.href = tabToggleEl.getAttribute("href");
//         },300)
//     });
//     tabToggleEl.addEventListener('mouseenter', function () {
//         tab.show();
//     });
//     tabToggleEl.offsetParent.addEventListener('mouseleave', function () {
//         tab.hide();
//     });
// });